// extracted by mini-css-extract-plugin
export default {"root":"Home_root__wcBFA","wrapper":"Home_wrapper__z935U","emptyWrapper":"Home_emptyWrapper__lksr+","header":"Home_header__wCgMR"};